import React from 'react';
import { JBAlert, JBTag } from '@jbhi-fi/lanyard-ui';
import IconPerksMascotWithLogo from '../../../../../../../assets/svg/icon-perks-mascot-with-logo.svg';
import IconPerksMascotBirthday from '../../../../../../../assets/svg/icon-perks-mascot-birthday.svg';
import { useCustomerApi } from '../../../hooks/customerApi';
import { getMonthStringFromInt } from '../../../utils';
import { styles } from './PerksWelcome.css';

export type PerksWelcomeProps = {
  heading?: string;
  content?: string;
  isCouponBlockShown?: boolean;
  isBirthdayBlockShown?: boolean;
  isBirthdayIcon?: boolean;
};

export const PerksWelcomeAlert = ({
  heading,
  content,
  isCouponBlockShown = false,
  isBirthdayBlockShown = false,
  isBirthdayIcon = false,
}: PerksWelcomeProps): JSX.Element => {
  const { customer } = useCustomerApi();

  return (
    <JBAlert type="info" classes={styles.alert} closable>
      <div className={styles.alertContainer}>
        <div className={styles.mascotContainer}>
          {isBirthdayIcon ? <IconPerksMascotBirthday /> : <IconPerksMascotWithLogo />}
        </div>
        <div>
          <h3>{heading}</h3>
          <p className={styles.contentContainer}>{content}</p>
          <div className={styles.couponWrapper}>
            {isCouponBlockShown ? (
              <PerkItem label="Perk Alert" styles={styles}>
                $10 welcome coupon <span className={styles.couponSentContainer}>Sent</span>
              </PerkItem>
            ) : null}
            {isBirthdayBlockShown && customer?.birthMonth ? (
              <PerkItem styles={styles} label="Birthday Perk">
                Birthday month:&nbsp;
                <span className={styles.birthdayMonth}>{getMonthStringFromInt(customer?.birthMonth)}</span>{' '}
                <span className={styles.couponSentContainer}>Saved</span>
              </PerkItem>
            ) : null}
          </div>
        </div>
      </div>
    </JBAlert>
  );
};

const PerkItem: React.FC<{ styles: { [key: string]: string }; label: string; children: React.ReactNode }> = ({
  styles,
  label,
  children,
}) => {
  return (
    <div className={styles.couponContainer}>
      <div className={styles.iconPerkAlertContainer}>
        <JBTag type="black" content={label} />
      </div>
      {children}
    </div>
  );
};
